import { useCallback } from 'react';
import { CompactSelection, GridSelection } from '@glideapps/glide-data-grid';

import { useDismissibleSelection } from './useDismissibleSelection';

export const createEmptyGlideDataGridSelection = (): GridSelection => ({
    columns: CompactSelection.empty(),
    rows: CompactSelection.empty(),
});

export const hasGlideDataGridCheckboxSelection = (selection: GridSelection) =>
    selection.columns.length > 0 || selection.rows.length > 0;

/**
 * Applies the platform checkbox-selection lifecycle to Glide Data Grid.
 * The grid container must carry `data-selection-control="true"` while active
 * so interactions inside the canvas do not count as outside clicks.
 */
export const useDismissibleGlideDataGridSelection = (
    selection: GridSelection,
    onSelectionChange: (selection: GridSelection) => void,
    onDismiss?: () => void,
) => {
    const active = hasGlideDataGridCheckboxSelection(selection);
    const clearSelection = useCallback(() => {
        onSelectionChange(createEmptyGlideDataGridSelection());
        onDismiss?.();
    }, [onDismiss, onSelectionChange]);

    useDismissibleSelection({ active, onDismiss: clearSelection });

    return { active, clearSelection };
};
